<template>
  <div class="agreement-page auto1200">
    <div class="header">
      <div class="title">申报单ID：{{ id }}</div>
      <ul class="links">
        <li><a @click="jump('/process')">查看详细入驻流程</a></li>
        <li><a href="https://www.yuque.com/docs/share/7489dfff-bc57-47fb-9af6-7696cdf67d4e" target="_blank">入驻帮助</a></li>
      </ul>
    </div>

    <!-- 步骤条 -->
    <div class="steps-card">
      <steps
        v-model="activeStep.index"
        :status="activeStep.status"
        :options="steps"
        success-status="process2"
      ></steps>
    </div>

    <!-- 运营审核中 -->
    <div v-if="signState === 'OPERATION_CHECKING'" class="prompt-card">
      <div class="icon"><img src="../assets/img/icon-audit-pending.png"></div>
      <div class="info">
        <div class="title">运营审核中</div>
        <div class="description">资质审核已完成，正在进行运营审核，请耐心等待<br>如有问题，请联系您的项目经理</div>
      </div>
    </div>

    <!-- 运营审核失败 -->
    <div v-if="signState === 'OPERATION_CHECK_FAILED' && !isEdit" class="prompt-card">
      <div class="icon"><img src="../assets/img/icon-audit-error.png"></div>
      <div class="info">
        <div class="title is-error">运营审核不通过</div>
        <div class="description">驳回原因：{{ signData.operationCheckRemark }}</div>
        <el-button class="mi-primary" size="mini" @click="showEdit">修改资质</el-button>
      </div>
    </div>

    <!-- 商家确认信息 -->
    <div v-if="['MERCHANT_CONFIRM', 'DEPARTMENT_CHECKING', 'DEPARTMENT_CHECK_FAILED', 'E_SIGN_FAILED'].includes(signState) && !isEdit" class="confirm-info">
      <div class="tips">请确认合同模版，并确认联系信息，企业信息，品牌及类目资质等相关信息无误</div>
      <el-form class="confirm-table" label-width="105px" size="mini">
        <el-form-item label="入驻类型：">{{ isOverseas ? '跨境商家' : '普通商家' }}</el-form-item>
        <el-form-item label="是否线上签约：">{{ signData.signOnline ? '是' : '否' }}</el-form-item>
        <el-form-item label="所属协议：">
          <a href="/api/zhaoshang/enter/有品平台服务协议.pdf" target="_blank">有品平台服务协议.pdf</a>
        </el-form-item>
        <div v-loading="loadingIframe" class="frame-wrapper">
          <iframe ref="iframe" src="/api/zhaoshang/enter/有品平台服务协议.pdf" frameborder="0"></iframe>
        </div>
      </el-form>
      <div v-if="signState === 'MERCHANT_CONFIRM'" class="button-group">
        <el-button class="mi-info" size="mini" @click="showEdit">修改资质</el-button>
        <el-button class="mi-primary" size="mini" @click="confirmContract">确认无误</el-button>
      </div>
    </div>

    <!-- 电子签章 -->
    <div v-if="signState === 'E_SIGNING'" class="e-sign">
      <div class="tips">
        <span class="icon"><i class="el-icon-check"></i></span>
        <span>协议已生成，请关注您的短信或者邮件，尽快完成签章。</span>
      </div>
      <p v-if="signData.partbSignUrl">协议链接：<a :href="signData.partbSignUrl" target="_blank">电子签章</a></p>
    </div>

    <!-- 修改资质 -->
    <div v-if="isEdit" class="edit-info">
      <audit-table :status="2"></audit-table>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { formatDate } from '@/utils'
import { confirmContract } from '@/api/merchant'
import Steps from '@/components/Steps.vue'
import AuditTable from '@/components/audit/AuditTable.vue'

export default {
  components: {
    Steps,
    AuditTable
  },
  data() {
    return {
      isEdit: false,
      loadingIframe: true
    }
  },
  computed: {
    ...mapState({
      id: 'applicationId',
      isOverseas: 'isOverseas',
      signState: 'signState',
      signData: 'signData',
      steps: state => {
        const { operationLog } = state
        return [
          { title: '运营审核', desc: formatDate(operationLog.SIGN_OPERATION_CHECK), error: '运营审核失败' },
          { title: '商家确认信息', desc: formatDate(operationLog.SIGN_MERCHANT_CONFIRM) },
          { title: '业务部审核', desc: formatDate(operationLog.SIGN_DEPARTMENT_CHECK), error: '业务部审核失败' },
          { title: '电子签章', desc: formatDate(operationLog.SIGN_E_SIGN), error: '电子签章失败' }
        ]
      },
      activeStep: state => {
        switch (state.signState) {
          case 'OPERATION_CHECKING': return { index: 0, status: 'process' }
          case 'OPERATION_CHECK_FAILED': return { index: 0, status: 'error' }
          case 'MERCHANT_CONFIRM': return { index: 1, status: 'process' }
          case 'DEPARTMENT_CHECKING': return { index: 2, status: 'process' }
          case 'DEPARTMENT_CHECK_FAILED': return { index: 2, status: 'error' }
          case 'E_SIGNING': return { index: 3, status: 'process' }
          case 'E_SIGN_FAILED': return { index: 3, status: 'error' }
          default: break
        }
      }
    })
  },
  mounted() {
    this.initIframe()
  },
  methods: {
    jump(path) {
      this.$router.push(path)
    },
    // 修改资质
    showEdit() {
      document.getElementById('main').scrollTop = 0
      this.isEdit = true
    },
    // 初始化 iframe
    initIframe() {
      const { iframe } = this.$refs
      if (!iframe) return
      if (iframe.attachEvent) iframe.attachEvent('onload', () => { this.loadingIframe = false })
      else iframe.onload = () => { this.loadingIframe = false }
    },
    // 商家确认信息
    async confirmContract() {
      const data = await confirmContract()
      if (!data.code) location.reload()
    }
  }
}
</script>

<style lang="less" scoped>
.steps-card {
  height: 124px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 32px;

  /deep/ .el-steps .el-step {
    .el-step__head.is-process .el-step__icon {
      background: #fff;
      .el-step__icon-inner {
        color: #457BFC;
      }
    }

    .el-step__head.is-process2 .el-step__icon {
      border-color: #457BFC;
      .el-step__icon-inner {
        color: #457BFC;
      }
    }
  }
}

.header {
  padding-top: 21px;
  padding-bottom: 13px;
  padding-left: 5px;
  border-bottom: 1px solid #DEDDDD;
  line-height: 12px;
  display: flex;
  justify-content: space-between;

  .title {
    font-size: 16px;
    font-weight: 500;
  }

  ul.links {
    width: 400px;
    margin: 0;
    padding-right: 5px;

    li {
      display: inline-block;
      margin-left: 30px;
    }
  }
}

a {
  font-size: 12px;
  color: #457BFC;
  text-align: center;
  line-height: 12px;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
    color: #457BFC;
  }
}

.prompt-card {
  display: flex;
  width: 360px;
  margin: 0 auto;
  margin-top: 125px;

  .info {
    margin-left: 20px;

    .title {
      margin-top: 4px;
      font-size: 18px;
      color: #3C7DEF;
      font-weight: 500;

      &.is-error {
        color: #ff7677;
      }
    }

    .description {
      font-size: 12px;
      color: #999999;
      line-height: 18px;
      margin-top: 7px;
      margin-bottom: 10px;
    }
  }
}

.confirm-info {
  .tips {
    font-size: 13px;
    color: #E67F0E;
  }
  .confirm-table {
    margin-top: 20px;
    .el-form-item.el-form-item--mini {
      margin-bottom: 12px;
    }
    .frame-wrapper {
      margin-top: 10px;
      margin-bottom: 20px;
      width: 1200px;
      z-index: 0;
      /deep/ .el-loading-mask {
        border-radius: 3px;
        background: #eee !important;
      }
    }
    iframe {
      width: 100%;
      border: 0;
      height: 800px;
      margin: 0;
      padding: 0;
      border-radius: 3px;
    }
  }

  .button-group {
    margin-bottom: 20px;
  }
}

.e-sign {
  margin-top: 20px;
  font-size: 13px;

  .tips {
    display: flex;
    align-items: center;
    .icon {
      display: inline-block;
      width: 18px;
      height: 18px;
      border-radius: 20px;
      border: 2px solid #457BFC;
      text-align: center;
      margin-right: 10px;
      i {
        color: #457BFC;
        font-weight: 900;
        font-size: 14px;
        line-height: 18px;
      }
    }
  }

  p {
    margin-left: 33px;
    margin-top: 20px;
    font-size: 13px;
  }
}

a {
  font-size: 13px;
  text-decoration: underline;
}
</style>
